import { endSentrySession, startSentrySession } from '@/config.ts'
import axios from 'axios'
import { v4 } from 'uuid'

export type CookieConsent = {
  consent: boolean
  essential: boolean
  analyticsAndPerformance: boolean
}

const requestCookieConsent = () => {
  void axios.put('/api/v1/cookie-consent')
}

const createCookieConsent = (cookieConsent: CookieConsent) => {
  return Object.entries(cookieConsent)
    .map(([key, value]) => `|${key}:${value}`)
    .join('')
}

const getCookieConsent = () => {
  const cookieConsent = document.cookie
    .split(';')
    .find((cookie) => cookie.trim().startsWith('cookieConsent='))
    ?.trim()

  if (!cookieConsent) {
    return null
  }
  const [_, consent] = cookieConsent.split('=')
  const result = {} as CookieConsent
  for (const keyValue of consent.split('|')) {
    const [key, value] = keyValue.split(':')
    if (key !== 'consentId') {
      result[key as keyof CookieConsent] = value === 'true'
    }
  }
  return result
}

export const initializeCookieConsent = () => {
  const existedCookieConsent = getCookieConsent()
  if (existedCookieConsent) {
    // this API call must be called when consent cookie is existed
    requestCookieConsent()
    const { analyticsAndPerformance } = existedCookieConsent
    if (analyticsAndPerformance) {
      startSentrySession()
    } else {
      endSentrySession()
    }
    return
  }
  const consentId = `consentId:${v4()}`
  const consent = createCookieConsent({
    consent: false,
    essential: true,
    analyticsAndPerformance: false,
  })
  document.cookie = `cookieConsent=${consentId}${consent}; path=/; SameSite=Lax; Max-Age=31536000;`
  // this API call must be called when consent cookie is existed
  requestCookieConsent()
  endSentrySession()
}

export const isCookieConsentDone = () => {
  const existedCookieConsent = getCookieConsent()
  if (!existedCookieConsent) {
    return false
  }
  return existedCookieConsent.consent
}

export const saveCookieConsent = (cookieConsent: CookieConsent) => {
  if (cookieConsent.analyticsAndPerformance) {
    startSentrySession()
  } else {
    endSentrySession()
  }
  const consentId = `consentId:${v4()}`
  const consent = createCookieConsent(cookieConsent)
  document.cookie = `cookieConsent=${consentId}${consent}; path=/; SameSite=Lax; Max-Age=31536000;`
  // this API call must be called when consent cookie is existed
  requestCookieConsent()
}
